module.exports = __webpack_public_path__ + "img/ofanoa_no.eb4060b7.png";